/**
 * Stripe Api
 */

/**
 * 결제 Url 생성
 * @param {*} app
 * @param {*} wsId 워크스페이스 ID
 * @param {*} wsDomain 워크스페이스 도메인
 * @param {*} priceId 상품 ID
 * @param {*} quantity 상품 수량
 * @param {*} updateUserInfoList Plan 으로 변경되는 userId List
 * @param {*} successUrl 성공 후 Callback Url
 * @param {*} cancelUrl 실패 혹은 취소 후 Callback Url
 * @param {*} mode 테스트 모드일시 test, 아니면 undefined
 * @returns
 */
export async function getStripePaymentUrl(
  app,
  wsId,
  wsDomain,
  userEmail,
  priceId,
  quantity,
  updateUserInfoList,
  successUrl,
  cancelUrl,
  mode
) {
  return await app.$axios.post(`/v1/stripe/create`, {
    wsId,
    wsDomain,
    userEmail,
    priceId,
    quantity,
    updateUserInfoList,
    successUrl,
    cancelUrl,
    mode,
  })
}

/**
 * 구독 정보 변경
 * @param {*} app
 * @param {*} wsId 워크스페이스 ID
 * @param {*} wsDomain 워크스페이스 도메인
 * @param {*} subId 구독 ID
 * @param {*} priceId 상품 ID
 * @param {*} quantity 수량
 * @param {*} updateUserInfoList 변경된 userId List
 * @param {*} mode 테스트 모드일시 test, 아니면 undefined
 * @returns
 */
export async function updateSubscription(app, wsId, wsDomain, subId, priceId, quantity, updateUserInfoList, mode) {
  return await app.$axios.post(`/v1/stripe/update`, {
    wsId,
    wsDomain,
    subId,
    priceId,
    quantity,
    updateUserInfoList,
    mode,
  })
}

/**
 * 상품 리스트 호출
 * @param {*} app
 * @param {*} mode 테스트 모드일시 test, 아니면 undefined
 * @returns
 */
export async function getProductList(app, stripeSubId, mode) {
  return await app.$axios.post(`/v1/stripe/product-list`, { stripeSubId, mode })
}

/**
 * 워크스페이스 Owner에게 Plan 업그레이드 요청 메일 전송
 * @param {*} app
 * @param {*} wsId 워크스페이스 ID
 * @param {*} userId 발신 유저 Id
 * @returns
 */
export async function requestUpgradePlan(app, wsId, userId) {
  return await app.$axios.post(`/v1/stripe/request-upgrade`, { wsId, userId })
}

/**
 * 유저의 customer-portal url 을 가져온다.
 * @param {*} app
 * @param {*} stripeSubId 구독 ID
 * @param {*} mode 테스트 모드일시 test, 아니면 undefined
 * @returns
 */
export async function getCustomerPortalUrl(app, stripeSubId, returnUrl, mode) {
  return await app.$axios.post(`/v1/stripe/customer-portal`, { stripeSubId, returnUrl, mode })
}
